<template>
  <div>
    <van-nav-bar
      title="待配送订单"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <van-col :span="24">
      <base-datetime v-model="queryCondition.begin_delivery_time" label="送货起始" />
    </van-col>
    <van-col :span="24">
      <base-datetime v-model="queryCondition.end_delivery_time" label="送货截止" />
    </van-col>
    <van-col :span="24">
      <van-col :span="18" style="padding-left: 10px;">
        <van-checkbox-group v-model="queryCondition.statusList" direction="horizontal">
          <template v-for="status in CONST.SELL_ORDER_STATUS">
            <van-checkbox :name="status.id" :key="status.id">{{ status.name }}</van-checkbox>
          </template>
        </van-checkbox-group>
      </van-col>
      <van-col :span="6" style="text-align: right; padding-right: 10px;">
        <base-button @click="query">查询</base-button>
      </van-col>
    </van-col>
    <van-col :span="24" style="text-align: right; padding-right: 10px;">
      合计：{{ totalSellCount }} 单
    </van-col>
    <van-col :span="24">
      <van-pull-refresh v-model="refreshing" @refresh="query">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="query"
        >
          <van-cell v-for="row in data" :key="row.id">
            <van-panel>
              <div slot="header">
                <van-col :span="16">
                  {{ row.code }}<br>
                </van-col>
                <van-col :span="8">
                  <span style="font-size: 16px; font-weight: bold; color: #dd6161;">
                    状态：{{ row.status | fmConst('SELL_ORDER_STATUS') }}
                  </span>
                </van-col>
              </div>
              <div slot="footer">
                <van-col :span="24" style="color: gray; font-size: 12px;">
                  送货地址：{{ row.receiver_addr }}
                </van-col>
                <van-col :span="14">
                  收货人：{{ row.receiver }}
                </van-col>
                <van-col :span="10">
                  联系电话：{{ row.receiver_phone }}
                </van-col>
                <van-col :span="14">
                  送货时间：{{ row.delivery_time }}
                </van-col>
              </div>
            </van-panel>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </van-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDeliveryOrderList } from '@/api/delivery/order'
export default {
  name: 'DeliveryOrderList',
  data() {
    return {
      data: [],
      loading: false,
      finished: false,
      refreshing: false,

      totalSellCount: 0,
      selectedRow: null,

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        type: this.CONST.ORDER_BILL_TYPES.find(type => type.name === '销售预订单').id,

        emp_id: 0,
        begin_delivery_time: this.Utils.df(null, '{y}-{m}-{d} 00:00:00'),
        end_delivery_time: '',
        statusList: [],
        statuses: ''
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.queryCondition.statusList = this.CONST.SELL_ORDER_STATUS
      .filter(status => status.id <= 6).map(status => status.id)
    this.queryCondition.emp_id = this.userInfo.emp_id
    this.query()
  },
  methods: {
    query() {
      this.data = []
      this.loading = true
      this.finished = false
      this.refreshing = false
      this.queryCondition.statuses = this.queryCondition.statusList.join(',')
      getDeliveryOrderList(this.queryCondition).then(resp => {
        const rows = resp.rows || []
        this.totalSellCount = 0
        rows.forEach(row => {
          this.totalSellCount += parseInt(row.sell_count || 0)
          if (row.details && row.details.length > 0) {
            row.details.forEach(detail => {
              this.data.push({
                code: detail.code,
                delivery_time: detail.delivery_time,
                receiver: detail.receiver,
                receiver_addr: detail.receiver_addr,
                receiver_phone: detail.receiver_phone,
                status: detail.status
              })
            })
          }
        })
        this.queryCondition.total = resp.total
        this.loading = false
        this.finished = true
      }).catch(error => {
        this.loading = false
        this.finished = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/delivery/order-list.vue